import {
  Component,
  DestroyRef,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter, Subject } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  host: { class: 'p-4' },
})
export class MenuComponent implements OnInit {
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  items = input<MenuItem[]>([]);
  menuItems$ = new Subject<MenuItem[]>();
  activeRoute = '';

  constructor() {
    effect(() => {
      const items = this.items();
      if (items && items.length) {
        this.menuItems$.next(items);
      }
    });
  }

  ngOnInit(): void {
    this.activeRoute = this.router.url;
    this.updateActiveStates();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.activeRoute = this.router.url;
        this.updateActiveStates();
      });
  }

  private updateActiveStates() {
    const getHasActiveChild = (children: MenuItem[]): boolean =>
      children.some(
        child =>
          child['active'] ||
          (child.items?.length ? getHasActiveChild(child.items) : false),
      );

    const updatedItems = (items: MenuItem[], parent?: MenuItem) =>
      items.map(item => {
        const route = item['route'];

        item['active'] = !!route && this.activeRoute === route;
        item['parent'] = parent;

        if (item.items?.length) {
          item.items = updatedItems(item.items, item);
          item['hasActiveChild'] = getHasActiveChild(item.items);
        }
        return item;
      });

    this.menuItems$.next(updatedItems(this.items()));
  }
}
